import Account, { FoxfordIAMProvider } from 'account'
import { parseQueryString } from './functions'

let account = null

export function initializeAccount () {
  const { account_id } = parseQueryString()

  account = new Account({
    id: account_id,
    provider: new FoxfordIAMProvider({
      endpoint: `${process.env.MEDIA_IDP_HOST}/api/media_services`
    })
  })

  return account
}

export async function authAccount () {
  const { access_token, refresh_token, expires_in } = parseQueryString()
  const options = {
    data: {
      access_token,
      refresh_token,
      expires_in: parseInt(expires_in)
    }
  }

  return account.signIn(options)
}

export async function getAccessToken () {
  try {
    const tokenData = await account.signIn()

    return tokenData.access_token
  } catch (err) {
    throw new Error('Missing access_token in account')
  }
}

export { account }



// WEBPACK FOOTER //
// ./src/utils/account.js